module.exports = __webpack_public_path__ + "img/mexico865.162867eb.jpg";